import type { FleetCarList } from '@ahd/shared/types/ahd-fleet-api/fleet-car/list';
import type { AdQuery } from '@ahd/shared/types/ahd-fleet-api/mobile/AdQuery';

import isUndefinedNullOrEmpty from '@ahd/shared/tools/is-undefined-null-or-empty';

import axios from '..';
import { type ConfigObject, type DebugLevel } from '../../../_configs/types';
import { sUrl } from '../../../vars';

export default function getAllFacets(idGroup: ConfigObject['general']['idGroup'], signal: AbortController['signal'], debug: DebugLevel) {
    const dataPathString = [];

    const dataPath: AdQuery = {
        idGroup,
        onlyFacetts: 'true',
        raw: 'false',
    };

    for (let i = 0; i < Object.keys(dataPath).length; i++) {
        const key = Object.keys(dataPath)[i];
        const value = dataPath[key];
        if (!isUndefinedNullOrEmpty(value) && value !== -100 && value !== '-100') dataPathString.push(key + '=' + value);
    }

    return axios<FleetCarList>({
        debug,
        idGroup,
        title: 'Abrufen der Facetten',
        noLogging: false,
        method: 'get',
        url: `${sUrl}/cars/?${dataPathString.join('&')}`,
        signal,
    });
}
